export default __webpack_public_path__ + "static/media/9Klein.167818ca.jpg";